import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, mergeMap, of } from 'rxjs';
import { contentBlockActions } from '../actions/content-block.actions';
import { HttpService } from '../services/http.service';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { selectContentBlock } from '../selectors/content-block.selectors';

@Injectable({
    providedIn: 'root',
})
export class ContentBlockEffects {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);
    private readonly httpService = inject(HttpService);

    getContentBlock$ = createEffect(() => {
        return this.actions.pipe(
            ofType(contentBlockActions.getContentBlock),
            concatLatestFrom(({ id }) => this.store.select(selectContentBlock(id))),
            filter(([, contentBlock]) => contentBlock === undefined || contentBlock === null),
            mergeMap(([{ id }]) =>
                this.httpService.getContentBlock(id).pipe(
                    map((blocks) => contentBlockActions.getContentBlockSuccess({ id, blocks })),
                    catchError(() => of(contentBlockActions.getContentBlockError({ id }))),
                ),
            ),
        );
    });
}
